/* eslint-disable eqeqeq */
import {

  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import $ from "jquery";
import { useEffect } from "react";
import DashBoard from "../tables/Dashboard/DashBoard"
import Booking from "../tables/booking/Booking";
import { AdminProfile } from "./AdminProfile";
import { Expert } from "../tables/expert/Expert";
import Category from "../tables/category/Category";
import Gallery from "../tables/gallery/Gallery";
import SubCategory from "../tables/subCategory/SubCategory";
import Service from "../tables/services/Service";
import { Review } from "../tables/review/Review";
import Tax from "../tables/tax/Tax";
import { User } from "../tables/User/User";
import Setting from "../tables/setting/Setting";
import ExpertProfile from "../tables/expert/ExpertProfile";
import WeekTime from "../tables/timeSlot/WeekTime";
import { useDispatch, useSelector } from "react-redux";
import UpcomingBooking from "../tables/booking/UpcomingBooking";
import StaffEarning from "../tables/StaffEarning";
import AttendanceTable from "../tables/AttendanceTable";
import UserProfile from "../tables/User/UserProfile";
import DailyBooking from "../tables/booking/DailyBooking";
import ExpertHistory from "../tables/expert/ExpertHistory";
import MonthlyReport from "../tables/MonthlyReport";
import Banner from "../tables/banner/Banner";
import Complain from "../tables/complain/Complain";
import ExpertBooking from "../tables/expert/ExpertBooking";
import AllPaymentHistory from "../tables/payment/AllPaymentHistory";
import ExpertPaymentHistory from "../tables/payment/ExpertWiseHistory";
import UserHistory from "../tables/User/UserHistory";
import Holiday from "../tables/timeSlot/Holiday";
import CalendarPage from "../tables/booking/CalendarPage";
import ExpertSettlementHistory from "../tables/payment/ExpertSettlementHistory";
import StaffCalendarPage from "../tables/booking/StaffCalendarPage";
import { getAdmin } from "../../redux/slice/authSlice";
import { getSetting } from "../../redux/slice/settingSlice";
import SidebarReceptionist from "./SidebarReceptionist";


const Admin = () => {
  const type = localStorage.getItem('type');
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { admin } = useSelector((state) => state.auth);
  useEffect(() => {
    dispatch(getAdmin());
    // console.log(admin);
    dispatch(getSetting());
  }, [dispatch]);

  useEffect(() => {
    if (
      location.pathname == "/" ||
      location.pathname == "/admin" ||
      location.pathname == "/admin/" ||
      location.pathname == ""
    ) {
      navigate("/admin/adminDashboard");

    }
  }, []);
  var webSize = $(window).width();

  return (
    <div className={`mainAdminGrid  ${webSize < 991 && "webAdminGrid"}`}>
      {admin?.type == 2 ? <SidebarReceptionist /> : <Sidebar />}

      <div className={`mainAdmin`}>
        <Navbar />
        <div className="adminStart">
          <Routes>
            <Route path="/bookingTable" element={<Booking />} />
            <Route path="/profile" element={<AdminProfile />} />
            <Route path="/reviewTable" element={<Review />} />
            <Route path="/tax" element={<Tax />} />
            <Route path="/userTable" element={<User />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/setting" element={<Setting />} />
            <Route path="/timeTable" element={<WeekTime />} />
            <Route path="/holiday" element={<Holiday />} />
            <Route path="/futureBooking" element={<UpcomingBooking />} />
            <Route path="/attendanceTable" element={<AttendanceTable />} />
            <Route path="/user/userProfile" element={<UserProfile />} />
            <Route path="/dailyBookingTable" element={<DailyBooking />} />
            <Route path="/bannerTable" element={<Banner />} />
            <Route path="/complainTable" element={<Complain />} />
            <Route path="/paymentHistory" element={<AllPaymentHistory />} />
            <Route path="/userHistory" element={<UserHistory />} />
            <Route path="/calenderPage" element={<CalendarPage />} />
            <Route path="/staffCalenderPage" element={<StaffCalendarPage />} />

            {/* Protected Routes: redirect receptionist (type 1) to /bannerTable */}

            <Route path="/categoryTable" element={type != 1 ? <Navigate to="/admin/bannerTable" replace /> : <Category />} />
            <Route path="/galleryTable" element={<Gallery />} />
            <Route path="/serviceTable" element={type != 1 ? <Navigate to="/admin/bannerTable" replace /> : <Service />} />

            <Route path="/monthlyReport"
              element={type != 1 ? <Navigate to="/admin/bannerTable" replace /> : <MonthlyReport />}
            />

            <Route
              path="/expert/history"
              element={type != 1 ? <Navigate to="/admin/bannerTable" replace /> : <ExpertHistory />}
            />
            <Route path="/adminDashboard"
              element={type != 1 ? <Navigate to="/admin/bannerTable" replace /> : <DashBoard />}
            />
            <Route
              path="/expert/booking"
              element={type != 1 ? <Navigate to="/admin/bannerTable" replace /> : <ExpertBooking />}
            />
            <Route
              path="/expert/paymentHistory"
              element={type != 1 ? <Navigate to="/admin/bannerTable" replace /> : <ExpertPaymentHistory />}
            />

            <Route path="/allExperts"
              element={type != 1 ? <Navigate to="/admin/bannerTable" replace /> : <Expert />}
            />

            <Route path="/staffEarning"
              element={type != 1 ? <Navigate to="/admin/bannerTable" replace /> : <StaffEarning />}
            />
            <Route
              path="/expert/getExpertProfile"
              element={type != 1 ? <Navigate to="/admin/bannerTable" replace /> : <ExpertProfile />}
            />
            <Route
              path="/expertSettlement"
              element={type != 1 ? <Navigate to="/admin/bannerTable" replace /> : <ExpertSettlementHistory />}
            />
          </Routes>

        </div>
      </div>
    </div>
  );
};

export default Admin;
